import React from 'react'

function ChevronUp() {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.80005 0.5L0.469921 5.75L9.13018 5.75L4.80005 0.5Z" fill="currentColor" />
    </svg>
  )
}

export default ChevronUp